let pendingBidFile: File | null = null;

export function setPendingBidFile(file: File | null) {
  pendingBidFile = file;
}

export function takePendingBidFile(): File | null {
  const f = pendingBidFile;
  pendingBidFile = null;
  return f;
}
